import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-ticket-nav',
  templateUrl: './ticket-nav.component.html',
  styleUrls: ['./ticket-nav.component.scss']
})
export class TicketNavComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
